import {
  Card,
  CardHeader,
  CardContent,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Stack,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../redux-store/hooks'
import { updateClientInfo } from '../../../services'
import { BottomSaveBar, ClientDiscountList } from '../components'

const ClientDiscountSettings = () => {
  const clientInfo = useAppSelector((state) => state.clientInfo.data)
  const dispatcher = useAppDispatch()
  const [dmanager, setDmanager] = useState(clientInfo.discountManager)

  const updateDiscountSettings = async () => {
    const tempClient = { ...clientInfo }
    tempClient.discountManager = {
      ...tempClient.discountManager,
      allowDefaultDiscount: dmanager.allowDefaultDiscount,
      allowDiscountOnTotalBill: dmanager.allowDiscountOnTotalBill,
      considerStrictProductSettings: dmanager.considerStrictProductSettings,
      isDiscountsApplicable: dmanager.isDiscountsApplicable,
    }
    await dispatcher(
      updateClientInfo({ clientId: tempClient._id || '', body: tempClient })
    )
  }

  useEffect(() => {}, [])

  return (
    <Stack p={2}>
      <Card>
        <CardHeader title="Discount Options" />
        <CardContent>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dmanager.isDiscountsApplicable}
                  onChange={(e) =>
                    setDmanager({
                      ...dmanager,
                      isDiscountsApplicable: e.target.checked,
                    })
                  }
                />
              }
              label="Enable Discounts"
            />
            <Stack ml={5}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!dmanager.isDiscountsApplicable}
                    checked={dmanager.allowDiscountOnTotalBill}
                    onChange={(e) =>
                      setDmanager({
                        ...dmanager,
                        allowDiscountOnTotalBill: e.target.checked,
                      })
                    }
                  />
                }
                label={
                  <span>
                    Allow Discount on Total Bill
                    <br />
                    <small>
                      Applies a discount on entire bill and shows option while
                      billing.
                    </small>
                  </span>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!dmanager.isDiscountsApplicable}
                    checked={dmanager.considerStrictProductSettings}
                    onChange={(e) =>
                      setDmanager({
                        ...dmanager,
                        considerStrictProductSettings: e.target.checked,
                      })
                    }
                  />
                }
                label={
                  <span>
                    Allow Product Specific Discounts
                    <br />
                    <small>
                      Overrides global discounts with product-specific settings.
                    </small>
                  </span>
                }
              />
            </Stack>
          </FormGroup>
        </CardContent>
      </Card>

      <ClientDiscountList />
      <BottomSaveBar onSave={updateDiscountSettings} />
    </Stack>
  )
}

export { ClientDiscountSettings }
